export enum TelcoMarketTypeEnum {
    RES = 'RES',
    PRO = 'PRO',
    OBS = 'OBS',
}
